import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const addHolidayShift = (data) => {
  return http.post("/HolidayShift/AddHolidayShift", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getListofProjects = () => {
  return http.get("/HolidayShift/GetListofProjects", {
    headers: { Authorization: "Bearer " + token },
  });
};

const getShiftbyEmpid = (data) => {
  return http.post("/HolidayShift/GetShiftbyEmpid", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getAllShiftHR = () => {
  return http.get("/HolidayShift/GetAllShift_HR", {
    headers: { Authorization: "Bearer " + token },
  });
};

const actiononHolidayShift = (data) => {
  return http.post("/HolidayShift/ActiononHoliday_Shift", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const editHolidayShift = (data) => {
  return http.post("/HolidayShift/EditHolidayShift", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const deleteHolidayShift = (data) => {
  return http.post("/HolidayShift/DeleteHolidayShift", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateWorkDone = (data) => {
  return http.post("/HolidayShift/UpdateWork_Done", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getWDListbyempid = (data) => {
  return http.post("/HolidayShift/GetWDListby_empid", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getListofWorkdone = () => {
  return http.get("/HolidayShift/GetListof_Workdone", {
    headers: { Authorization: "Bearer " + token },
  });
};

const HolidayShiftService = {
  addHolidayShift,
  getListofProjects,
  getShiftbyEmpid,
  getAllShiftHR,
  actiononHolidayShift,
  editHolidayShift,
  deleteHolidayShift,
  updateWorkDone,
  getWDListbyempid,
  getListofWorkdone,
};

export default HolidayShiftService;
